import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  private scrollEvent = new BehaviorSubject<string | null>(null); // Emite eventos de desplazamiento
  scrollEvent$ = this.scrollEvent.asObservable(); // Observable que otros pueden escuchar

  scrollTo(section: string) {
    this.scrollEvent.next(section); // Guarda el evento
  }

  getPendingScroll(): string | null {
    return this.scrollEvent.getValue(); // Devuelve el último evento si existe
  }

  clearScroll() {
    this.scrollEvent.next(null); // Limpia el evento después de ejecutarlo
  }
}
